export default __webpack_public_path__ + "static/media/pantry1-afterB-2048w.08c847f9.png";